import script from "./FeeReceiptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FeeReceiptModal.vue?vue&type=script&setup=true&lang=js"

import "./FeeReceiptModal.vue?vue&type=style&index=0&id=28c5f579&lang=css"

const __exports__ = script;

export default __exports__